import digitalData from 'digital-data';
import { OVERLAY } from '../constants';
import { getPageType } from '../thd-analytics-utils';

export const checkNearbyStore = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('cart.select-store', ({ output }) => {
    const { cartAnalytics, cartReqParams } = output || {};
    const { isBopisAvailable, enableCheckNearbyStoreView } = cartAnalytics || {};
    const { itemId } = cartReqParams || {};
    if (enableCheckNearbyStoreView) {
      digitalData.event = digitalData.event || [];
      const ddoEvent = {
        category: {
          primaryCategory: OVERLAY,
        },
        eventInfo: {
          eventName: 'check nearby stores',
          displayType: 'list',
        },
        item: [
          {
            productInfo: {
              sku: itemId,
            },
            fulfillment: {
              method: isBopisAvailable ? 'bopis' : 'boss',
            },
          },
        ],
        overlayLocation: getPageType(),
      };
      digitalData.event.push(ddoEvent);
    }
  });
};
